import { e as entry, b as _toConsumableArray, f as handleUrl } from './index2.js';
import 'tty';
import 'os';
import 'deepmerge';
import 'axios';
import 'vue';
import { n as normalizeComponent } from './normalize-component.js';

var script = {
  mixins: [entry],
  mounted: function mounted() {
    var _this = this;

    _toConsumableArray(this.$el.querySelector('.c-text-entry__content').getElementsByTagName('a')).forEach(function (element) {
      element.addEventListener('click', _this.onLinkInTextClick);
    }); // local development workaround, to render images in textentries


    var textImages = this.$el.querySelector('.c-text-entry__content').getElementsByTagName('img');

    if (textImages && textImages.length > 0) {
      textImages.forEach(function (element) {
        console.log('element.src', element.src);
        var baseUrl = _this.$xp.settings.baseUrl; // new regex

        if (element.src.match(/^http|https:\/\/localhost:[0-9]*\//)) {
          element.src = element.src.replace(/^(http|https):\/\/localhost:[0-9]*\//, baseUrl);
        } else if (element.src.match(/^(app:\/\/local\/)/)) {
          element.src = element.src.replace(/^(app:\/\/local\/)/, baseUrl);
        } else if (element.src.match(/^(file:\/\/\/android_asset\/www\/)/)) {
          element.src = element.src.replace(/^(file:\/\/\/android_asset\/www\/)/, baseUrl);
        }
      });
    }
  },
  methods: {
    onLinkInTextClick: function onLinkInTextClick(e) {
      e.preventDefault();
      var targetAnchor = e.target.tagName === 'A' ? e.target : e.target.closest('a');

      if (targetAnchor.href) {
        var matches = targetAnchor.href.match(/PageID=(\d+)/);
        var url = '';

        if (matches && matches[1]) {
          url = "/page/".concat(matches[1]);
        } else {
          url = targetAnchor.href;
        }

        handleUrl(url, this.$router);
      }

      this.$el.dispatchEvent(new Event(e.type, e));
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "js-entry o-entry c-text-entry" }, [
    _c("div", {
      staticClass: "c-text-entry__content",
      domProps: { innerHTML: _vm._s(_vm.entryData.Json.Text) }
    })
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=TextEntry.js.map
